'use client'
import { LuneTheme } from '@lune-fe/lune-ui-lib'
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import Link from 'next/link'

export const BlogPreview = ({
    title,
    url,
    target,
}: {
    title: string
    url: string
    target?: string
}) => {
    const { palette } = LuneTheme

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                maxWidth: { md: '320px', xs: '100%' },
                borderTop: '1px solid',
                borderColor: palette.Grey900,
                pt: 2,
                pb: 2,
                a: {
                    color: palette.Grey900,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    textDecoration: 'none',
                    width: '100%',
                    '&:hover, &:focus': {
                        textDecoration: 'underline',
                    },
                },
            }}
        >
            <Link target={target || '_blank'} href={url}>
                <Text variant={'caption'}>{title}</Text>
                <ArrowForwardOutlinedIcon />
            </Link>
        </Box>
    )
}
